import { createSelector } from 'reselect';

export const selectProfileGroupsSlice = state => state.profileGroups;

export const selectProfileGroups = createSelector(
  selectProfileGroupsSlice,
  slice => slice.profileGroups
);
export const profileGroupsLoaded = createSelector(
  selectProfileGroupsSlice,
  slice => slice.profileGroupsLoaded
);
export const selectActiveProfileGroup = createSelector(
  selectProfileGroupsSlice,
  slice => slice.activeProfileGroup
);

export const profileGroupsMeta = createSelector(
  selectProfileGroupsSlice,
  slice => slice.meta
);
export const profileGroupsFilters = createSelector(
  selectProfileGroupsSlice,
  slice => slice.filters
);

export const profileGroupCreating = createSelector(
  selectProfileGroupsSlice,
  slice => slice.isCreating
);
export const profileGroupUpdating = createSelector(
  selectProfileGroupsSlice,
  slice => slice.isUpdating
);
export const profileGroupDeleting = createSelector(
  selectProfileGroupsSlice,
  slice => slice.isDeleting
);
export const profileGroupsErrors = createSelector(
  selectProfileGroupsSlice,
  slice => slice.errors
);
